/* eslint-disable camelcase */
import React from 'react';
import { dateFormat } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var dueInterestReferenceColumns = [{
  name: 'Дата',
  value: 'date',
  dateTimeFormat: dateFormat
}, {
  name: 'Договор №',
  value: 'number',
  width: '110px'
}, {
  name: 'Падежирала лихва сума',
  render: function render(_ref) {
    var interest = _ref.interest,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "interest"
    }, interest, " ", currency);
  }
}];